import { render, staticRenderFns } from "./HighlightInProductList.vue?vue&type=template&id=0174b3a4&"
import script from "./HighlightInProductList.vue?vue&type=script&lang=js&"
export * from "./HighlightInProductList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0174b3a4')) {
      api.createRecord('0174b3a4', component.options)
    } else {
      api.reload('0174b3a4', component.options)
    }
    module.hot.accept("./HighlightInProductList.vue?vue&type=template&id=0174b3a4&", function () {
      api.rerender('0174b3a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Forms/HighlightInProductList.vue"
export default component.exports